import React from 'react';
import { SingleAuthorTemplate } from '../single-author';
import { getAuthorNameKeyword, getDevider} from '../utils';

import './photo-low-priority-single-author.m.css';


export function PhotoLowPrioritySingleAuthorTemplate(props) {
  const photoPriorityPropsObj = Object.assign({}, props, {
    authorNameKeyword: getAuthorNameKeyword(),
    storyPubKeyword: getDevider(),
    hideImage: true
  });

  return <div styleName="photo-low-priority-single-author">
    <SingleAuthorTemplate {...photoPriorityPropsObj} />
  </div>;
}